import { Eye, Lock, ShieldCheck, Trash2 } from 'lucide-react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAlert, Spin, Badge, DataTable, SearchInput, IconButton, FormDrawer, InfoBar, Modal, PageHeader, TableStatusBar } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import AddGroup from './Buttons/AddGroup';
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import UpdateGroup from './Buttons/UpdateGroup';
import FormGroupUpdate from './Forms/FormGroupUpdate';

export default function GestionGroup() {
	// USER TOKEN
	const authHeader = useAuthHeader()
	// USER SESSION
	const auth = useAuthUser()
	const user: User = JSON.parse(JSON.stringify(auth() || {}))
	const alert = useAlert()

	const [data, setData] = useState([])

	const [arrierePlan, setArrierePlan] = useState([])
	const [habilitation, setHabilitation] = useState([])
	const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

	const [dataTri, setDataTri] = useState<any>([])

	const [loading, selLoading] = useState(false)
	const [textRes, setTextRes] = useState("")

	useEffect(() => {
		LoadData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	function LoadData() {
		selLoading(true)
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: env.API_BASE_URL + datas.API_LINKs.GroupeHabilitations,
			headers: {
				'Accept': 'text/plain',
				'Authorization': authHeader(),
				'CipherCodeU': Crypter.encrypt(user.CodeU)
			}
		};

		axios.request(config)
			.then((response: any) => {
				const res = JSON.parse(Crypter.decrypt(response.data)).Value
				if (res.StatutCode == 200) {
					selLoading(false)

					const groupes: any = []
					const ap: any = []

					res.Result[0].map((g: any) => {
						if (g.Statut != 2) {
							groupes.push({ id: g.RoleId, RoleId: g.RoleId, Libelle: g.Libelle, DateCreated: g.DateCreated, Statut: g.Statut, Habilitations: g.RoleId, Actions: g.RoleId }
							)
							ap.push({ id: g.RoleId, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy, IsActif: g.IsActif == 1 ? 'Oui' : 'Non', Level: g.Level })
						}
					})

					setDataTri(groupes)
					setArrierePlan(ap)
					setHabilitation(res.Result[1])


				}
				else {
					selLoading(false)
					setDataTri([])
					//localStorage.setItem("tabGuichet", JSON.stringify([]))
					setTextRes("")
					alert.warning(response.data.message)
				}
			})
			.catch((error: any) => {
				setTextRes("")
				alert.error('Error', error)
				selLoading(false)
				console.log(error);
			});
	}

	function tri(type: string) {

		var dte: any[] = []
		if (type == "a") {
			dte = data
		} else {
			data.map((el: any) => {
				if (el.Statut == type) {
					dte.push(el)
				}
			})

		}
		setDataTri(dte)

		setTextRes(dte.length + " Resultat(s) obtenu")

	}
	const columns: DataTableColumn[] =
		[
			{ field: 'RoleId', headerName: 'ID Groupe', width: 150 },
			{ field: 'Libelle', headerName: 'Libelle', width: 150 },
			{ field: 'DateCreated', headerName: 'Date création', width: 150 },
			{
				field: 'Statut', headerName: 'Statut', width: 70, renderCell: ({ value }) => (
					<Badge color={value == 1 ? "blue" : "red"}>
						{value == 1 ? "actif" : "bloqué"}
					</Badge>
				),
			},
			{
				field: 'Habilitations', headerName: 'Habilitation', width: 160,
				renderCell: ({ value }) => {
					const count = habilitation.filter((ha: any) => ha.RoleId == value).length
					return (
						<div className="flex items-center gap-2">
							<Badge color={count > 0 ? 'violet' : 'gray'}>{count} habil.</Badge>
							<IconButton tooltip='Voir les habilitations' color="primary" size={28}
								onClick={(e) => { e.stopPropagation(); openHabilitations(value) }}>
								<Eye size={15} />
							</IconButton>
						</div>
					)
				},
			},
			{
				field: 'Actions', headerName: 'Actions', width: 150,
				renderCell: ({ value }) => (
					<div className="flex items-center gap-2">
						<IconButton tooltip='Retirer de la file' color='danger' size={28}><Trash2 size={16} /></IconButton>
						<UpdateGroup handleFunction={() => { LoadData() }} groupe={[dataTri.find((ar: any) => (ar.id == value)), habilitation.filter((ha: any) => (ha.RoleId == value))]} />
						<IconButton tooltip='Bloquer' size={28}><Lock size={16} /></IconButton>
					</div>
				),
			},
		];

	function handleRowClick(e: any) {
		setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
	}

	const [open, setOpen] = useState(false)
	const [groupe, setGroupe] = useState<any>()

	// Modal de visualisation des habilitations d'un groupe
	const [openHab, setOpenHab] = useState(false)
	const [groupeHab, setGroupeHab] = useState<any>(null)

	function openHabilitations(roleId: any) {
		setGroupeHab({
			groupe: dataTri.find((ar: any) => ar.id == roleId),
			list: habilitation.filter((ha: any) => ha.RoleId == roleId),
		})
		setOpenHab(true)
	}

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Spin spinning={loading} >
			<PageHeader
				title="Gestion des groupes"
				subtitle="Paramétrez les groupes et leurs habilitations"
				actions={<AddGroup handleFunction={() => { LoadData() }} />}
			/>
			<div className="eb-table-wrap">
				<SearchInput onSearch={LoadData} size='lg' placeholder='Saisissez pour effectuer une recherche' className="mb-3" />
				<DataTable onRowClick={handleRowClick} rows={dataTri} height={300} columns={columns} searchable />
			</div>
			<TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
			<InfoBar data={[
				{ label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
				{ label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
				{ label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
				{ label: 'Niveau', value: arrierePlanSelected?.Level },
			]} />

			<FormDrawer
				open={open}
				onClose={handleClose}
				title={`Modification du groupe ${groupe?.Libelle || ''}`}
				hint="Ajustez le libellé et les habilitations du groupe puis enregistrez."
			>
				<FormGroupUpdate handleFunction={() => { setOpen(false); LoadData() }} groupe={groupe} />
			</FormDrawer>

			{/* Visualisation des habilitations du groupe */}
			<Modal
				open={openHab}
				onClose={() => { setOpenHab(false); setGroupeHab(null) }}
				title={`Habilitations — ${groupeHab?.groupe?.Libelle || groupeHab?.groupe?.RoleId || ''}`}
				width={520}
			>
				{!groupeHab?.list?.length && (
					<p className="text-sm text-[var(--eb-text-muted)]">Aucune habilitation associée à ce groupe.</p>
				)}
				<div className="flex flex-col gap-1.5 max-h-80 overflow-y-auto">
					{(groupeHab?.list || []).map((h: any, i: number) => (
						<div key={h.CodeHabi || i} className="flex items-center gap-2.5 px-3 py-2 rounded-lg border border-[var(--eb-border)]">
							<ShieldCheck size={15} className="flex-shrink-0 text-[var(--eb-primary)]" />
							<span className="font-mono text-xs font-semibold text-[var(--eb-primary)]">{h.CodeHabi}</span>
							<span className="text-sm text-[var(--eb-text)]">{h.Libelle}</span>
						</div>
					))}
				</div>
			</Modal>
		</Spin>
	);
}
